import script from "./BuyNewProxy.vue?vue&type=script&setup=true&lang=js"
export * from "./BuyNewProxy.vue?vue&type=script&setup=true&lang=js"

import "./BuyNewProxy.vue?vue&type=style&index=0&id=73e38c4f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73e38c4f"]])

export default __exports__